export enum CommentSourceEnum {
  Order = 'ORDER',
  Service = 'SERVICE',
  Tender = 'TENDER',
  Product = 'PRODUCT',
  Auction = 'AUCTION',
}
